import React from 'react';

const JobSearch = () => {
  return (
    <div className='Block px-5' style={{marginTop:"50px"}}>
        <div className='d-flex jobSearch'>
            <div className="dropdown jobBtn">
                <button className="btn dropdown-toggle" id='btn' type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Job Collection
                </button>
                <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="/">Action</a></li>
                    <li><a className="dropdown-item" href="/">Another action</a></li>
                    <li><a className="dropdown-item" href="/">Something else here</a></li>
                </ul>
            </div>
            <div className="dropdown jobBtn">
                <button className="btn dropdown-toggle" id='btn' type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Remote Job
                </button>
                <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="/">Action</a></li>
                    <li><a className="dropdown-item" href="/">Another action</a></li>
                    <li><a className="dropdown-item" href="/">Something else here</a></li>
                </ul>
            </div>
            <div className="dropdown jobBtn">
                <button className="btn dropdown-toggle" id='btn' type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Job By Location
                </button>
                <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="/">Action</a></li>
                    <li><a className="dropdown-item" href="/">Another action</a></li>
                    <li><a className="dropdown-item" href="/">Something else here</a></li>
                </ul>
            </div>
            <div className="dropdown jobBtn">
                <button className="btn dropdown-toggle" id='btn' type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Job By Role
                </button>
                <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="/">Action</a></li>
                    <li><a className="dropdown-item" href="/">Another action</a></li>
                    <li><a className="dropdown-item" href="/">Something else here</a></li>
                </ul>
            </div>
            <div className="dropdown jobBtn">
                <button className="btn dropdown-toggle" id='btn' type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Job By Role & Location
                </button>
                <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="/">Action</a></li>
                    <li><a className="dropdown-item" href="/">Another action</a></li>
                    <li><a className="dropdown-item" href="/">Something else here</a></li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default JobSearch